import angular from 'angular';

angular
  .module('cloudX')
  .controller('CompanyCtrl', [
    '$scope',
    '$q',
    'Blob',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    '$http',
    'optionsSvc',
    '$timeout',
    'checkSecurity',
    'checkTenantConfiguration',
    'ModalService',
    '$stateParams',
    compCtrl,
  ]);

function compCtrl(
  $scope,
  $q,
  Blob,
  dataCache,
  resourceFactorySvc,
  flySvc,
  $http,
  optionsSvc,
  $timeout,
  checkSecurity,
  checkTenantConfiguration,
  ModalService,
  $stateParams,
) {
  var vm = this;
  var resource = resourceFactorySvc.get('company');
  vm.errors = {};

  $scope.companies = [];
  $scope.activeCompany = null;
  $scope.ownCompanyRelations = [];

  resourceFactorySvc.get('relation').names({ crmTypes: [4] }, function(data) {
    $scope.ownCompanyRelations = data;
  });
  resource.getAll(null, function(data) {
    $scope.companies = data;
    $scope.activeCompany =
      ($stateParams.companyId
        ? $scope.companies.find(x => x.id === $stateParams.companyId)
        : null) || $scope.companies[0];

    $scope.notVatLiable = $scope.activeCompany.vatNumber === '';
    $scope.oldValue = $scope.activeCompany.vatNumber;

    if (
      !$scope.activeCompany.enterpriseNumber &&
      checkSecurity('CompanyOwn:u') &&
      checkTenantConfiguration('[0,1]')
    ) {
      flySvc.proposal(
        '',
        'msgCompanyFillInEnterpriseNrCBE',
        function() {
          $scope.enterpriseNumberForm.$show();
        },
        'btnEditEnterpriceNr',
      );
    }
  });

  vm.profassnumber = [
    {
      id: 0,
      text: 'AIB',
    },
    {
      id: 1,
      text: 'BIBF',
    },
    {
      id: 2,
      text: 'IBA',
    },
    {
      id: null,
      text: 'Other',
    },
  ];

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  // Everthing for vatNumber logic
  $scope.maskOptions = {
    clearOnBlur: false,
  };

  $scope.setFocus = function(id) {
    angular.element(document.querySelector('#' + id)).focus();
  };

  $scope.setActiveCompany = companyId => {
    if (!companyId) return;
    const company = $scope.companies.find(x => x.id === companyId);
    $scope.activeCompany = company;
  };

  $scope.changeFormState = function() {
    if ($scope.notVatLiable) {
      $scope.vatForm.$cancel();
      // we submit here with required = false so that '' would pass the validation!
      $scope.submit('', 'vatNumber', false).then(function() {
        $scope.activeCompany.vatNumber = '';
        $scope.oldValue = '';
      });
    } else {
      $scope.vatForm.$show();
      $timeout(function() {
        $scope.setFocus('vatString');
      }, 50);
    }
  };

  $scope.handleKeyUp = function($event) {
    if ($event.keyCode === 27) {
      $scope.vatNumber = $scope.oldValue;
      $scope.notVatLiable = $scope.vatNumber === '';
      $scope.vatForm.$cancel();
    }

    if ($event.keyCode === 13) {
      $scope.vatForm.$submit();
    }
  };

  $scope.submitVat = function($data) {
    //Validation error
    if (typeof $data === 'undefined') return '';
    if ($scope.notVatLiable) return $scope.submit('', 'vatNumber');
    else {
      // If no value is returned (empty string) we need to save null => Update: vatNumber is required, so we don't save if no value is returned
      // (Convention: null = not filled out, "" = not VAT liable)
      // BUT if value is undefined entry is incomplete: warning + return '' for xEditable
      if (typeof $data.vatString === 'undefined') {
        flySvc.message('msgIncompleteEntryInMaskIsNoSave');
        return '';
      }
      if ($data.vatString === '') {
        // If vatNumber is required, making it empty is not allowed
        flySvc.error('msgRequiredField');
        return ''; // return undefined = close input - reject: stays open!
      }
      return $scope.submit($data.vatString, 'vatNumber').then(function() {
        $scope.activeCompany.vatNumber = $data.vatString;
        $scope.oldValue = $data.vatString;
      });
    }
  };
  $scope.saving = false;
  $scope.submit = function($data, field, showSuccess = true) {
    if ($scope.saving) return $q.when('');
    //Validation error
    if (typeof $data === 'undefined') {
      if (vm.errors) {
        for (var error in vm.errors) {
          if (vm.errors.hasOwnProperty(error) && error[0] !== '$') {
            if (vm.errors[error].code) {
              if (vm.errors[error].code === 3000) flySvc.error('msgRequiredField');
              else flySvc.error(vm.errors[error].code, vm.errors[error].parameters, field);
            }
          }
        }
      }
      return $q.when('');
    }

    // if new value = old value do nothing
    if (angular.equals($scope.activeCompany[field], $data)) return $q.when(false);

    var model = angular.copy($scope.activeCompany);
    model[field] = $data;

    $scope.saving = true;
    // put copy to server
    return resource.update(model).$promise.then(
      function(success) {
        $timeout(function() {
          angular.extend($scope.activeCompany, success);
          dataCache.updateCompany($scope.activeCompany);
        }, 100);

        if (success.foundInKBO === null || success.foundInKBO === true) {
          if (showSuccess) flySvc.success('msgConfirmChange');
        } else if (checkTenantConfiguration('[0,1]')) {
          flySvc.message('msgCompanyCBENotFound');
        }
        $scope.saving = false;
        return false;
      },
      function(error) {
        $scope.saving = false;
        // error callback return error? (edit remains open)
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };
  $scope.ownCompanyRelationChanged = id => {
    if (id === $scope.activeCompany.ownCompanyRelation?.id) return false;
    const relation = id ? $scope.ownCompanyRelations.find(x => x.id === id) : null;
    return $scope.submit(relation, 'ownCompanyRelation');
  };

  $scope.openBankAccountsDialog = () => {
    ModalService.showModal({
      template: require('./dialogs/companyBankAccountsDialog.html'),
      controller: 'CompanyBankAccountsDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        companyId: $scope.activeCompany.id,
        bankAccounts: $scope.activeCompany.bankAccounts,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });

      modal.close.then(function(result) {
        $timeout(function() {
          $scope.activeCompany.bankAccounts = result;
        }, 100);
      });
    });
  };

  $scope.showCreateCompanyModal = function() {
    ModalService.showModal({
      template: require('./dialogs/addCompanyDialog.html'),
      controller: 'AddCompanyDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });

      modal.close.then(function(result) {
        if (!result) return;
        $scope.companies.push(result);
        var dataCacheCompanies = dataCache.getArray('company');
        dataCacheCompanies.push(result);
        flySvc.success('msgConfirmChange');
        // run in timeout to change active tab, dont use angular.extend
        // because it will cause the "old" active company to have the new company's property
        $timeout(function() {
          $scope.activeCompany = result;
        }, 100);
      });
    });
  };
}
